import {Component, OnInit, ViewChild} from "@angular/core";
import {MatPaginator} from "@angular/material/paginator";
import {MatSort, MatSortable} from "@angular/material/sort";
import {MatTableDataSource} from "@angular/material/table";
import {Router} from "@angular/router";
import {faAngleRight} from "@fortawesome/free-solid-svg-icons";
import {TranslateService} from "@ngx-translate/core";
import {OrdersApiService} from "src/app/api/orders-api.service";
import {AuthManagerService} from "src/app/auth/auth-manager.service";
import {LoginData, User} from "src/app/auth/auth.model";
import {LensConfigMode, LensSectionMode, LensSide, LensType} from "src/app/model/configuration/configuration";
import {ArticleType, LensOrderItem, OrderItem} from "src/app/model/order/order";
import {i18nService} from "src/app/service-utils/i18n.service";
import {CartService} from "src/app/utils/cart/cart.service";
import {LanguagePickerService} from "src/app/utils/language-picker/language-picker.service";
import {MessageService} from "src/app/utils/message/message.service";
import {NewOrderStoreService} from "../new-order-store-service.service";
import {NoopScrollStrategy} from "@angular/cdk/overlay";
import {NewOrderSelectDialogComponent} from "../new-order-select-dialog/new-order-select-dialog.component";
import {MatDialog} from "@angular/material/dialog";
import {FormBuilder, FormGroup} from "@angular/forms";
import {of} from 'rxjs';
import {debounceTime, tap, switchMap, filter, map, startWith, distinctUntilChanged} from 'rxjs/operators';
import {ChangeAccountService} from "../../utils/change-account.service";

@Component({
  selector: 'app-new-order-confirm',
  templateUrl: './new-order-confirm.component.html',
  styleUrls: ['./new-order-confirm.component.scss']
})
export class NewOrderConfirmComponent implements OnInit {

  readonly linkIcon = faAngleRight;

  cartItems: OrderItem[];
  currentUser: User;
  displayedColumnsCareAccessories: string[] = ['type', 'name', 'warning', 'unit', 'actions'];
  displayedColumnsLenses: string[] = ['type', 'name', 'info', 'side', 'commission', 'desire-date', 'return', 'actions'];

  lensesItems: any;
  showLenses: boolean;
  @ViewChild('lensesPaginator', {static: true}) lensesPaginator: MatPaginator;
  @ViewChild('lensesSort', {static: true}) lensesSort: MatSort;

  careItems: any;
  showCare: boolean;
  @ViewChild('carePaginator', {static: true}) carePaginator: MatPaginator;
  @ViewChild('careSort', {static: true}) careSort: MatSort;

  accessoriesItems: any;
  showAccessories: boolean;
  @ViewChild('accessoryPaginator', {static: true}) accessoryPaginator: MatPaginator;
  @ViewChild('accessorySort', {static: true}) accessorySort: MatSort;

  isGroupAccount: boolean;
  searchForm: FormGroup;
  searchResult = [];
  accounts = [];

  constructor(private authManagerService: AuthManagerService,
              private translate: TranslateService,
              private cartService: CartService,
              private ordersApi: OrdersApiService,
              private message: MessageService,
              private router: Router,
              private i18nService: i18nService,
              private languagePickerService: LanguagePickerService,
              private newOrderStoreService: NewOrderStoreService,
              private dialog: MatDialog,
              private formBuilder: FormBuilder,
              private changeAccountService: ChangeAccountService) {
    this.currentUser = this.authManagerService.currentUser;
    this.changeAccountService.isGroupAccount().subscribe(value => this.isGroupAccount = value);
  }

  ngOnInit(): void {
    this.cartService.getCartItems().subscribe(data => {
      this.cartItems = data;
      this.careItems = new MatTableDataSource<OrderItem>(this.cartItems.filter(item => item.article.type === ArticleType.CARE));
      this.createSortAndPagintaion(this.careItems, this.carePaginator, this.careSort);
      this.accessoriesItems = new MatTableDataSource<OrderItem>(this.cartItems.filter(item => item.article.type === ArticleType.ACCESSORY));
      this.createSortAndPagintaion(this.accessoriesItems, this.accessoryPaginator, this.accessorySort);
      this.lensesItems = new MatTableDataSource<OrderItem>(this.sortLenses(this.cartItems));
      this.createSortAndPagintaion(this.lensesItems, this.lensesPaginator, this.lensesSort, true);
    });

    this.cartService.cartItems$.subscribe(data => {
      this.cartItems = data;
      this.careItems = new MatTableDataSource<OrderItem>(this.cartItems.filter(item => item.article.type === ArticleType.CARE));
      this.createSortAndPagintaion(this.careItems, this.carePaginator, this.careSort);
      this.accessoriesItems = new MatTableDataSource<OrderItem>(this.cartItems.filter(item => item.article.type === ArticleType.ACCESSORY));
      this.createSortAndPagintaion(this.accessoriesItems, this.accessoryPaginator, this.accessorySort);
      this.lensesItems = new MatTableDataSource<OrderItem>(this.sortLenses(this.cartItems));
      this.createSortAndPagintaion(this.lensesItems, this.lensesPaginator, this.lensesSort, true);
    });

    this.changeAccountService.accounts.filter(line => {
      this.accounts.push(line.customerNumber);
    });
    this.searchForm = this.formBuilder.group({
      searchBar: ''
    });
    this.onChanges();
  }

  onChanges() {
    this.searchForm.get('searchBar').valueChanges.pipe(
      //filter( data => data.trim().length > 0 ),
      debounceTime(500),
      switchMap((customerNumber: string) => {
        return customerNumber ? this.changeAccountService.searchingValue(customerNumber.replace(/[\s]/g, '')) : of([]);
      })
    ).subscribe(data => {
      this.searchResult = data as Array<{}>;
    })
  }

  changeAccount() {
    this.changeAccountService.getAccounts().forEach(account => {
      if (account.customerNumber == this.searchForm.controls['searchBar'].value) {
        let loginData: LoginData = {
          'customerNumber': account.customerNumber,
          'username': '',
          'password': ''
        };
        this.authManagerService.change(loginData, account.customerName).subscribe(response => {
          if (response.success) {
            this.currentUser = this.authManagerService.currentUser;
            this.message.info('home.login.success');
          } else {
            this.message.errorCode('home.login.fail');
          }
        });
      }
    });
  }

  addLenses() {
    this.dialog.open(NewOrderSelectDialogComponent, {
      data: {
        copy: true
      },
      autoFocus: false,
      width: '650px',
      scrollStrategy: new NoopScrollStrategy()
    });
  }

  sortLenses(items: OrderItem[]): OrderItem[] {
    items = items.filter(item => item.article.type === ArticleType.LENS);
    items.sort((a, b) =>
      (a as LensOrderItem).commission.localeCompare((b as LensOrderItem).commission) ||
      (b as LensOrderItem).side.charAt(0).localeCompare((a as LensOrderItem).side.charAt(0)));
    return items;
  }

  createSortAndPagintaion(items: MatTableDataSource<OrderItem>, paginator: MatPaginator, sort: MatSort, isLenses = false) {
    if (isLenses) {
      items.sortingDataAccessor = (item, property) => {
        switch (property) {
          case 'name':
            return item.article.name;
          case 'info':
            return this.getInfo(item as LensOrderItem);
          default:
            return item[property];
        }
      };
    } else {
      items.sortingDataAccessor = (item, property) => {
        switch (property) {
          case 'name':
            return item.article.name;
          default:
            return item[property];
        }
      };
    }
    items.sort = sort;
    items.paginator = paginator;
    this.sortLenses(this.cartItems);
  }

  sendOrder() {
    this.cartService.getCartItems().subscribe(orderItems => {
      let lens = orderItems.filter(orderItem => orderItem.article.type === ArticleType.LENS);
      let cares = orderItems.filter(orderItem => orderItem.article.type !== ArticleType.LENS);
      let cleanLensCares = orderItems.filter(orderItem => orderItem.orderItemId && orderItem.orderItemId > 0);
      this.ordersApi.cleanCart({orderItems: cleanLensCares}).subscribe(() => {
      });
      if (lens.length > 0) {
        this.ordersApi.createOrder({orderItems: this.sortLenses(lens)}).subscribe(response => {
          if (response.success) {
            this.message.info("newOrder.messages.sent");
            this.newOrderStoreService.sendOrder();
          }
        });
      }
      if (cares.length > 0) {
        setTimeout(() => {
          this.ordersApi.createOrder({orderItems: cares}).subscribe(response => {
            if (response.success) {
              this.message.info("newOrder.messages.sent");
              this.newOrderStoreService.sendOrder();
            }
          });
        }, 100);
      }
    });
    this.cartService.clearCart();
    this.router.navigate(['/home']);
  }

  editLens(item: LensOrderItem, index: number) {
    this.newOrderStoreService.changeLensConfigMode(LensConfigMode.SINGLE);
    document.querySelector('#final-lens').scrollIntoView();
    this.newOrderStoreService.changeLensSectionMode(LensSectionMode.FINAL_LENS);
    if (item.side === LensSide.RIGHT) {
      this.newOrderStoreService.setIsRightSideEnable(true);
      this.newOrderStoreService.setIsLeftSideEnable(false);
      this.newOrderStoreService.setEditFinalLensRight(Object.assign({}, item), index);
    } else {
      this.newOrderStoreService.setIsLeftSideEnable(true);
      this.newOrderStoreService.setIsRightSideEnable(false);
      this.newOrderStoreService.setEditFinalLensLeft(Object.assign({}, item), index);
    }
    this.newOrderStoreService.editLensSideEnable();
    this.router.navigate(['/new-order'], {fragment: 'final-lens'});
  }

  getPrivacyNoteLink() {
    return this.translate.get('newOrder.confirm.info.privacyNote').pipe(
      map(tr => "<a href='http://www.hecht-kontaktlinsen.de/index.php/datenschutz' target='_blank'>" + tr + "</a>")
    );
  }

  getUseConditionLink() {
    return this.translate.get('newOrder.confirm.info.useCondition').pipe(
      map(tr => "<a href='http://www.hecht-kontaktlinsen.de/index.php/agb' target='_blank'>" + tr + "</a>")
    );
  }

  deleteCareAccessoryItem(item) {
    this.cartService.deleteCartItem(item);
  }

  getInfo(item: LensOrderItem) {
    return this.i18nService.getLensesDescriptionOrderConfirm(item);
  }

  isEnglish(): boolean {
    return this.languagePickerService.getLanguageCode() === 'en';
  }

  getSide(item: any): string {
    return (item.side) ? item.side.charAt(0) : '';
  }

  getExclamationHint(): string {
    let hint: string = "";
    this.translate.get("newOrder.equipment.electronicOrdering").subscribe(data => hint = data);
    return hint;
  }

  transformDate(date: any): string {
    let result = '';
    if (date != null) {
      if (date instanceof Date) {
        if (date.getDate().toString().length > 1) {
          result += date.getDate().toString();
        } else {
          result += '0';
          result += date.getDate().toString();
        }
        result += '.';
        if ((date.getMonth() + 1).toString().length > 1) {
          result += (date.getMonth() + 1);
        } else {
          result += '0';
          result += (date.getMonth() + 1);
        }
        result += '.';
        result += date.getFullYear();
      } else {
        result += date.substring(8, 10);
        result += '.';
        result += date.substring(5, 7);
        result += '.';
        result += date.substring(0, 4);
      }
    }
    return result;
  }

  notify(date: any): boolean {
    if (date != null) {
      if (date instanceof Date) {
        if (date.getMinutes() == 1) {
          return true;
        }
      } else if (date.length > 0) {
        return date.includes(':01:00');
      }
    }
    return false;
  }
}
